module.exports = __webpack_public_path__ + "static/media/bistecca-2.90ab2b9c.jpg";